import React from 'react';
import Slider from "react-slick";
import Nextarrow from './samecontent/Nextarrow';
import PrevArrow from './samecontent/PrevArrow';
import './Top.css';


const TopbrandList=[{
  id:1,
  time:"30 min",
  cover:"https://b.zmtcdn.com/data/brand_creatives/logos/1a985408ca7ad8fd097f2c47db9c5cb6_1611252598.png?output-format=webp",  
},
{
    id:2,
    time:"39 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/874c2b2b4554f4aed7dd3bb4e755c420_1604383019.png?output-format=webp",  
  },
  {
    id:3,
    time:"37 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/ec72c289aa01d947fe15a009ce8e559f_1616052816.png?output-format=webp",  
  },
  {
    id:4,
    time:"39 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/7a7904eff687a7456599074a4e7d2335_1617875100.png?output-format=webp",  
  },
  {
    id:5,
    time:"39 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/2159c4a55b3ff2362678141e6a83645f_1622476257.png?output-format=webp",  
  },
  {
    id:6,
    time:"41 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/80c09d718acddee05a655eb378bb442f_1617875125.png?output-format=webp",  
  },
  {
    id:7,
    time:"38 min",
    cover:"https://b.zmtcdn.com/data/brand_creatives/logos/6a11fd0f30c9fd9ceaff2f5b21f61d23_1617187721.png?output-format=webp",  
  },
  
]


const TopBand = () => {
    
        const settings = {
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            nextArrow:<Nextarrow />,
            prevArrow:<PrevArrow />,
          };
    return (
        <>
         <div className="top-brand container">
             <div className="brand-title-name">
Top Brand for You
             </div>
             <Slider {...settings}>
{
    TopbrandList.map((brand)=>{
        return <div>
            <div className="cover">
                <img className="brand-image" src={brand.cover} alt={brand.cover}  />
            </div>
        </div>
    })
}
             </Slider>
         </div>   
        </>
    )
}

export default TopBand
